export const isUserLoggedIn = () => {
  return (
    localStorage.getItem("usuarioId") && localStorage.getItem("accessToken")
  );
};

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */

export const getHomeRouteForLoggedInUser = (userRole) => {
  if (localStorage.getItem("redirect_after_login")) {
    let redirect_url = localStorage.getItem("redirect_after_login");
    localStorage.removeItem("redirect_after_login");
    return redirect_url;
  }
  // poner despues, pero ajustar para cuando entren diferentes roles
  // if (localStorage.getItem("back_redirect_after_login")) {
  //   let redirect_url = localStorage.getItem("back_redirect_after_login");
  //   localStorage.removeItem("back_redirect_after_login");
  //   return redirect_url;
  // }

  if (["Autor", "Cliente", "Usuario", "Partner"].includes(userRole))
    return { name: "home" };
  return { name: "home" };
  // if(['administrador','super administrador','Desarrollador'].includes(userRole.toLowerCase())){
  //   return { name: "home" };
  // }else if(['cliente','usuario'].includes(userRole.toLowerCase())){
  //   return {name:'home-cliente'};
  // }
};
